import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import Products from "@/pages/products/page";
import About from "@/pages/about/page";
import Leather from "@/pages/leather/page";
import Purchase from "@/pages/purchase/page";
import Contact from "@/pages/contact/page";
import Access from "@/pages/access/page";
import Legal from "@/pages/legal/page";
import Privacy from "@/pages/privacy/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/products",
    element: <Products />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/leather",
    element: <Leather />,
  },
  {
    path: "/purchase",
    element: <Purchase />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/access",
    element: <Access />,
  },
  {
    path: "/legal",
    element: <Legal />,
  },
  {
    path: "/privacy",
    element: <Privacy />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;